var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('simple-button',{attrs:{"slot":"reference","mapgl":_vm.mapgl,"module":_vm.module,"layer-id":_vm.id,"icon":"closed","title":"Перекрытия","add-handler":_vm.addHandler,"layers-ids":_vm.layersIds},slot:"reference"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }